import { ref } from 'vue'
import { REQUEST_STATUS } from '@/shared/data/requestStatus.js'
import axios from 'axios'

export const useDoubleUpQueueTax = () => {
  const subtotal = ref(0)
  const tax = ref(0)
  const total = ref(0)
  const requestStatus = ref(REQUEST_STATUS.IDLE)
  const abortController = ref(new AbortController())

  const fetchDoubleUpQueueTax = async () => {
    if (
      requestStatus.value === REQUEST_STATUS.PENDING &&
      !abortController.value.signal.aborted
    ) {
      return abortController.value.abort()
    }

    try {
      abortController.value = new AbortController()
      requestStatus.value = REQUEST_STATUS.PENDING
      const { data } = await axios.get('/session-limits/prices', {
        signal: abortController.value.signal,
      })
      subtotal.value = data.subtotal
      tax.value = data.tax
      total.value = data.total
      requestStatus.value = REQUEST_STATUS.SUCCESS
    } catch (error) {
      if (error.message === 'canceled') return
      requestStatus.value = REQUEST_STATUS.ERROR
    }
  }

  return {
    subtotal,
    tax,
    total,
    requestStatus,
    fetchDoubleUpQueueTax,
  }
}
